import { useState } from "react";
import { APP_IOS } from "../config";
import { currentPlatform } from "../lib/flags";

// Badge oficial de Apple, servido por su herramienta de marketing (no se puede
// redibujar ni modificar). En español de México: «Descárgalo en el App Store».
const BADGE = "https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/es-mx";

/**
 * Enlace a la app de iPhone y iPad en el login.
 *
 * La app es Unlisted: nadie la encuentra buscando en la App Store, así que esta
 * es la puerta. No se pinta donde no sirve:
 *  - dentro de la propia app (la cáscara carga esta misma web);
 *  - en Android, que no tiene app;
 *  - abierta por archivo (USB / kiosco sin red), donde ni el badge carga.
 * Si el badge no carga, queda el enlace en texto: el destino importa más que el dibujo.
 */
export function DescargaApp() {
  const [sinBadge, setSinBadge] = useState(false);
  if (!visible()) return null;
  return (
    <a className="login-app" href={APP_IOS.url} target="_blank" rel="noopener noreferrer">
      {sinBadge ? (
        <span className="login-app-texto">Descarga la app para iPhone y iPad</span>
      ) : (
        <img src={BADGE} alt="Descárgalo en el App Store" onError={() => setSinBadge(true)} />
      )}
    </a>
  );
}

function visible(): boolean {
  try {
    if (currentPlatform() === "movil") return false;
    if (/android/i.test(navigator.userAgent)) return false;
    if (window.location.protocol === "file:") return false;
    return true;
  } catch {
    return false;
  }
}
